import classnames from 'classnames'
import React from 'react'
import * as styles from './index.module.scss'

interface ErrorMessage {
  errorMsg: string
  errorDetail: string
}

interface FilterErrorGuardProps {
  message?: ErrorMessage
  hasError: boolean
  className?: string
}

export const FilterErrorGuard = (props: FilterErrorGuardProps): JSX.Element | null => {
  if (!props.hasError) {
    return null
  }

  const errorStyles = 'filterSummary__error'

  return (
    <>
      <div className={classnames(styles[errorStyles], props.className)}>
        {props.message?.errorMsg}
      </div>
      <div className={props.className}>{props.message?.errorDetail}</div>
      <br />
    </>
  )
}
